import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';
import {Provider, connect} from 'react-redux';
import {persistStore} from 'redux-persist';
import {PersistGate} from 'redux-persist/integration/react';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import 'dayjs/locale/zh-cn';
import Analytics from 'react-router-ga';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.locale('zh-cn');

import store from './store/store';

import IndexScreen from './Screens/IndexScreen';
import NavBar from './Components/NavBar';
import style from './Styles/App.css';
import EventsScreen from "./Screens/EventsScreen";
import EventDetailScreen from "./Screens/EventDetailScreen";
import LiveDetailScreen from "./Screens/LiveDetailScreen";
import LivesScreen from "./Screens/LivesScreen";

const persistor = persistStore(store);

class Routes extends React.PureComponent {
  render() {
    return <Provider store={store}>
      <Router>
        <Analytics id="UA-122822682-1">
          <NavBar/>

          <PersistGate loading={null} persistor={persistor}>
            <div className={style.container}>
              <Route exact path='/' component={IndexScreen}/>
              <Route exact path='/lives' component={LivesScreen}/>
              <Route path='/lives/:tab(new|updated)' component={LivesScreen}/>
              <Route path='/lives/:id(\d+)' component={LiveDetailScreen}/>
              {/*<Route exact path='/lives/realtime' component={LivesScreen}/>*/}
              {/*<Route path='/events/:id' component={EventDetailScreen}/>*/}
              <Route exact path='/events' component={EventsScreen}/>
            </div>
          </PersistGate>
        </Analytics>
      </Router>
    </Provider>
  }
}


// React.render(<Routes />, document.body)
ReactDOM.render(<Routes/>, document.getElementById('app'));
